import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';

export const AccessDenied = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/dashboard');
  };

  return (
    <Box
      sx={{
        height: '100vh',
        width: '100vw',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: '24px',
      }}
    >
      <LockIcon sx={{ width: '56px', height: '56px' }} color='primary' />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <Typography variant='h6' align='center'>
          {t('accessDeniedPage.title')}
        </Typography>
        <Typography variant='body2'>
          {t('accessDeniedPage.subtitle')}
        </Typography>
      </Box>
      <Button variant='outlined' onClick={handleBack}>
        {t('accessDeniedPage.backBtn')}
      </Button>
    </Box>
  );
};
